interface Props {
  costUsd?: number | null; credits?: number | null; applicable?: boolean; known?: number; total?: number;
}
export function ElevenLabsCost({ costUsd, credits, applicable = true, known, total }: Props): JSX.Element {
  if (!applicable) return <span className="text-text-secondary">—</span>;
  return <div>
    <span className="whitespace-nowrap">{costUsd == null
      ? credits == null ? 'Noch nicht verfügbar' : 'USD nicht verfügbar'
      : `${costUsd.toLocaleString('de-DE', { minimumFractionDigits: 4, maximumFractionDigits: 4 })} USD`}</span>
    {credits != null && <div className="mt-1 text-xs text-text-secondary">{credits.toLocaleString('de-DE')} Credits</div>}
    {known != null && total != null && total > 0 && <div className={`mt-1 text-xs ${known < total ? 'text-warning' : 'text-text-secondary'}`}>
      USD-Belege: {known} von {total} Gesprächen
    </div>}
  </div>;
}
